<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">Order Cancellation Confirmation</h5>
  </div>
  <div class="modal-body">
    <p >Are you sure you want to cancel this order?</p>

    <form [formGroup]="cancellationForm">
      @if (isTypeCommentsOnly) {
        <div class="form-group">
          <mat-form-field appearance="fill" class="clrsgn-form-field">
            <mat-label for="reason" class="clrsgn-label">Please enter comments regarding cancelling this order</mat-label>
            <textarea formControlName="reason"
              matInput
              maxlength="200"
            rows="3"></textarea>
          </mat-form-field>
        </div>
      }

      @if (!isTypeCommentsOnly) {
        <div class="form-group">
          <mat-form-field appearance="fill" class="clrsgn-form-field">
            <mat-label>Reason</mat-label>
            <input formControlName="reason"
              [matAutocomplete]="autocompleteTypeLookupCode"
              aria-label="Reason"
              matInput
              type="text" />
              <mat-autocomplete [displayWith]="optOutReasonsDisplay(optOutReasons)"
                #autocompleteTypeLookupCode="matAutocomplete">
                @for (optOutReason of filteredOptOutReasons | async; track optOutReason) {
                  <mat-option
                    [value]="optOutReason.typeLookupCode">
                    {{ optOutReason.value }}
                  </mat-option>
                }
              </mat-autocomplete>
              <app-form-error [group]="cancellationForm"
                [controlName]="'reason'"
              customErrorMessage="Choose an option from the list."></app-form-error>
            </mat-form-field>
          </div>
        }

        @if (!isTypeCommentsOnly) {
          <div class="form-group mb-0">
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label for="comments" class="clrsgn-label">Comments</mat-label>
              <textarea formControlName="comments"
                matInput
                maxlength="3000"
              rows="3"></textarea>
            </mat-form-field>
          </div>
        }
      </form>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn-secondary" (click)="close()">Back</button>
      <button type="button" class="btn-secondary-warning" (click)="cancel()">Cancel Order</button>
    </div>
  </ng-container>
